import { render } from "./PatientDetailsDynamicTab.vue?vue&type=template&id=ffd8afe0&scoped=true"
import script from "./PatientDetailsDynamicTab.vue?vue&type=script&lang=js"
export * from "./PatientDetailsDynamicTab.vue?vue&type=script&lang=js"

import "./PatientDetailsDynamicTab.vue?vue&type=style&index=0&id=ffd8afe0&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffd8afe0"]])

export default __exports__